<!--
 * @version: V1.0.0
 * @Date: 2023-08-14 16:25:54
 * @LastEditors: lzq
 * @LastEditTime: 2023-11-17 15:11:06
 * @company: 睿展数据
 * @FilePath: \udi-wms-client\src\views\material\components\addOrEditCategory.vue
 * @Descripttion:
-->
<!--  -->
<template>
  <el-dialog v-loading.fullscreen="loading" :append-to-body="true" :title="categoryInfo.id ? '编辑分组' : '新增分组'"
    :visible="visible" width="450px" :destroy-on-close="true" :wrapper-closable="false" :show-close="false"
    :close-on-press-escape="false" :close-on-click-modal="false">
    <el-form ref="form" :rules="rules" :model="form" label-width="120px">
      <el-form-item label="父级分组" prop="parentMaterialGroupId">
        <el-cascader v-model="form.parentMaterialGroupId"
          :props="{ checkStrictly: true, children: 'children', label: 'materialGroupName', value: 'materialGroupId' }"
          :options="categoryData" placeholder="请选择内容"></el-cascader>
      </el-form-item>
      <el-form-item label="分组名称" prop="materialGroupName">
        <el-input v-model="form.materialGroupName" style="width: 200px;" placeholder="请输入分组名称"></el-input>
      </el-form-item>
      <el-form-item label="分组编码" prop="materialGroupCode">
        <el-input v-model="form.materialGroupCode" :disabled="form.id" style="width: 200px;" placeholder="请输入分组编码"></el-input>
      </el-form-item>
    </el-form>

    <span slot="footer" class="dialog-footer">
      <el-button @click="$emit('close')">取 消</el-button>
      <el-button type="primary" @click="submit"> 确 定 </el-button>
    </span>
  </el-dialog>
</template>

<script>
import {
  saveOrUpdateMaterialCategory,
} from '@/api/material'
import { findParent } from '@/utils/ruoyi.js'
export default {
  name: 'AddOrEditMaterial',
  props: {
    visible: {
      type: Boolean,
      default() {
        return false
      }
    },
    categoryInfo: {
      type: Object,
      default() {
        return {}
      }
    },
    // 分组
    categoryData: {
      type: Array,
      default() {
        return []
      }
    },
  },
  data() {
    // 这里存放数据
    return {
      loading: false,
      form: {},
      rules: {
        parentMaterialGroupId: [
          {
            required: true,
            message: '请选择父级分组',
            trigger: ['change', 'blur']
          }
        ],
        materialGroupName: [
          {
            required: true,
            message: '请输入分组名称',
            trigger: ['change', 'blur']
          }
        ],
        materialGroupCode: [
          {
            required: true,
            message: '请输入分组编码',
            trigger: ['change', 'blur']
          }
        ]
      }
    }
  },
  created() {
    if (this.categoryInfo.id) {
      this.form = JSON.parse(JSON.stringify(this.categoryInfo))
      const result = []
      findParent(this.categoryData, { materialGroupId: this.form.parentMaterialGroupId }, result, 'materialGroupId')
      this.form.parentMaterialGroupId = result
    }
  },
  // 方法集合
  methods: {
    // 保存
    submit() {
      this.$refs.form.validate((valid) => {
        if (!valid) return
        this.loading = true
        const params = JSON.parse(JSON.stringify(this.form));
        params.parentMaterialGroupId = params.parentMaterialGroupId[this.form.parentMaterialGroupId.length - 1]
        saveOrUpdateMaterialCategory(params).then(() => {
          this.$emit('close')
        }).finally(() => {
          this.loading = false

        })
      })
    }
  }
}
</script>
